<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="isCodeDisabled" v-decorator="['code', validatorRules.code]" :placeholder="$t('label.pleaseEnterTheDocumentNo')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input  v-decorator="['name', validatorRules.name]" :placeholder="$t('label.pleaseEnterTheName')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="产品分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag  v-decorator="['category', validatorRules.category]" dict="efs_stocking_prod_cat,name,code" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="饲料产品类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag v-decorator="['clazz']" dict="efs_stocking_feed_prod_cat,name,code" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="成本项目" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag v-decorator="['buffer1', validatorRules.buffer1]" dict="efs_stocking_cost_item,name,code" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx"  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'

  export default {
    name: 'EfsMdMmGroupForm',
    components: {
      JFormContainer,
      JDictSelectTag,
      JSearchSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        isCodeDisabled: false,
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          code: {
            rules: [
              { required: true, message: '请输入编码!'},
              { validator: (rule, value, callback) => validateDuplicateValue('efs_md_mm_group', 'code', value, this.model.id, callback)},
            ]
          },
          name: {
            rules: [
              { required: true, message: '请输入名称!'},
              { validator: (rule, value, callback) => validateDuplicateValue('efs_md_mm_group', 'name', value, this.model.id, callback)},
            ]
          },
          category: {
              rules: [
                  { required: true, message: '请选择产品分类!'},
              ]
          },
          /*clazz: {
              rules: [
                  { required: true, message: '请选择饲料产品类别!'},
              ]
          },*/
          buffer1: {
              rules: [
                  { required: true, message: '请选择成本项目!'},
              ]
          },
        },
        url: {
          add: "/materialGroup/efsMdMmGroup/add",
          edit: "/materialGroup/efsMdMmGroup/edit",
          queryById: "/materialGroup/efsMdMmGroup/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'code','name','category','clazz','buffer1','validFlag'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'code','name','category','clazz','buffer1','validFlag'))
      },
    }
  }
</script>